export const isUndefined = (value: unknown) => typeof value === 'undefined';
